<template>
	<paper-app>
		<router-view></router-view>
	</paper-app>
</template>

<script>
import PaperApp from '@jamescoyle/paper-vue/core/paper-app'

export default {
	components: {
		PaperApp,
	},
}
</script>

<style lang="scss">
@import '~@jamescoyle/paper-css/layout/grid';
@import '~@jamescoyle/paper-css/layout/flex';

@import '~@jamescoyle/paper-css/component/card';
</style>